<template>
  <div class="classroomDetails">
    <div class="classroomDetailsTop">
      <el-row :gutter="20" style="overflow: hidden;">
        <el-col :span="8" style="float: left;">
          <el-page-header @back="goBack" content=""> </el-page-header>
        </el-col>

        <el-col :span="16" style="float: right;"> </el-col>
      </el-row>
    </div>
    <div
      style="width: 100%;position: relative;height: 1px;background-color: #ECECEC;z-index: 9;"
    ></div>
    <el-row :gutter="5">
      <el-col :span="6">
        <div :style="{ height: heightStyle }" style="background-color: #fff;">
          <div class="wrap" style="padding-top: 30px;">
            <div style="overflow: hidden; padding: 0 20px;">
              <div
                v-if="type == 'Month'"
                style="float: left;cursor: pointer;"
                @click="preMonth"
              >
                <span v-if="activeIcon == '1'">
                  <svg
                    t="1711506695633"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4420"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                      fill="#c6e2ff"
                      p-id="4421"
                    ></path>
                    <path
                      d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                      fill="#409EFF"
                      p-id="4422"
                    ></path>
                  </svg>
                </span>
                <span v-if="activeIcon == ''">
                  <svg
                    t="1711506695633"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4420"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                      fill="#bfbfbf"
                      p-id="4421"
                    ></path>
                    <path
                      d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                      fill="#bfbfbf"
                      p-id="4422"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                v-if="type == 'week'"
                style="float: left;cursor: pointer;"
                @click="preMonthweek"
              >
                <span v-if="activeIcon == '1'">
                  <svg
                    t="1711506695633"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4420"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                      fill="#c6e2ff"
                      p-id="4421"
                    ></path>
                    <path
                      d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                      fill="#409EFF"
                      p-id="4422"
                    ></path>
                  </svg>
                </span>
                <span v-if="activeIcon == ''">
                  <svg
                    t="1711506695633"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4420"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                      fill="#bfbfbf"
                      p-id="4421"
                    ></path>
                    <path
                      d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                      fill="#bfbfbf"
                      p-id="4422"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                v-if="type == 'today'"
                style="float: left;cursor: pointer;"
                @click="preMonthtoday"
              >
                <span v-if="activeIcon == '1'">
                  <svg
                    t="1711506695633"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4420"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                      fill="#c6e2ff"
                      p-id="4421"
                    ></path>
                    <path
                      d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                      fill="#409EFF"
                      p-id="4422"
                    ></path>
                  </svg>
                </span>
                <span v-if="activeIcon == ''">
                  <svg
                    t="1711506695633"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4420"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2c256 0 467.2 211.2 467.2 467.2S768 979.2 512 979.2 51.2 768 51.2 512 256 51.2 512 51.2M512 0C230.4 0 0 230.4 0 512s230.4 512 512 512 512-230.4 512-512S793.6 0 512 0z"
                      fill="#bfbfbf"
                      p-id="4421"
                    ></path>
                    <path
                      d="M588.8 633.6L435.2 492.8l166.4-153.6s6.4-6.4 6.4-19.2c0-12.8-12.8-19.2-19.2-19.2-6.4 0-12.8 6.4-12.8 6.4l-19.2 19.2L390.4 480c-6.4 0-6.4 6.4-6.4 12.8s0 12.8 6.4 19.2l160 147.2 25.6 19.2c6.4 6.4 6.4 6.4 12.8 6.4 12.8 0 19.2-12.8 19.2-19.2 0-6.4-6.4-12.8-6.4-19.2l-12.8-12.8z"
                      fill="#bfbfbf"
                      p-id="4422"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                v-if="type == 'Month'"
                style="float: right;cursor: pointer;"
                @click="nextMonth"
              >
                <span v-if="activeIcon1 == '1'">
                  <svg
                    t="1711506799553"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6442"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                      fill="#c6e2ff"
                      p-id="6443"
                    ></path>
                    <path
                      d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                      fill="#409EFF"
                      p-id="6444"
                    ></path>
                  </svg>
                </span>
                <span v-if="activeIcon1 == ''">
                  <svg
                    t="1711506799553"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6442"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                      fill="#bfbfbf"
                      p-id="6443"
                    ></path>
                    <path
                      d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                      fill="#bfbfbf"
                      p-id="6444"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                v-if="type == 'week'"
                style="float: right;cursor: pointer;"
                @click="nextMonthweek"
              >
                <span v-if="activeIcon1 == '1'">
                  <svg
                    t="1711506799553"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6442"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                      fill="#c6e2ff"
                      p-id="6443"
                    ></path>
                    <path
                      d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                      fill="#409EFF"
                      p-id="6444"
                    ></path>
                  </svg>
                </span>
                <span v-if="activeIcon1 == ''">
                  <svg
                    t="1711506799553"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6442"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                      fill="#bfbfbf"
                      p-id="6443"
                    ></path>
                    <path
                      d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                      fill="#bfbfbf"
                      p-id="6444"
                    ></path>
                  </svg>
                </span>
              </div>
              <div
                v-if="type == 'today'"
                style="float: right; cursor: pointer;"
                @click="nextMonthtoday"
              >
                <span v-if="activeIcon1 == '1'">
                  <svg
                    t="1711506799553"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6442"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                      fill="#c6e2ff"
                      p-id="6443"
                    ></path>
                    <path
                      d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                      fill="#409EFF"
                      p-id="6444"
                    ></path>
                  </svg>
                </span>
                <span v-if="activeIcon1 == ''">
                  <svg
                    t="1711506799553"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="6442"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M512 51.2C256 51.2 44.8 262.4 44.8 518.4S256 979.2 512 979.2 972.8 768 972.8 512 768 51.2 512 51.2zM512 0c281.6 0 512 230.4 512 512s-230.4 512-512 512-512-230.4-512-512 230.4-512 512-512z"
                      fill="#bfbfbf"
                      p-id="6443"
                    ></path>
                    <path
                      d="M435.2 633.6l153.6-140.8-166.4-153.6s-6.4-6.4-6.4-19.2c0-12.8 12.8-19.2 19.2-19.2 6.4 0 12.8 6.4 12.8 6.4l19.2 19.2 166.4 153.6c6.4 0 6.4 6.4 6.4 12.8s0 12.8-6.4 19.2l-160 147.2-25.6 19.2c-6.4 6.4-6.4 6.4-12.8 6.4-12.8 0-19.2-12.8-19.2-19.2 0-6.4 6.4-12.8 6.4-19.2l12.8-12.8z"
                      fill="#bfbfbf"
                      p-id="6444"
                    ></path>
                  </svg>
                </span>
              </div>

              <div
                style="text-align: center;font-weight: 500;font-size: 16px;color: #323233;"
              >
                <span>{{ curYear }} 年 {{ curMonth }} 月</span>
              </div>
            </div>
            <div class="weeks">
              <div
                v-for="item in week"
                :key="item"
                class="week"
                style="color: #939496;"
              >
                {{ item }}
              </div>
            </div>
            <div class="days">
              <!-- 上个月 -->
              <div
                v-for="item in firstDay - 1"
                :key="item + 'pre'"
                class="lastday"
              >
                {{ preDays - (firstDay - 1 - item) }}
              </div>
              <!-- 当月 -->
              <div
                v-for="item in generateDays(curDays)"
                :key="item + 'cur'"
                class="curday"
                @click="clickBtn(item)"
              >
                <!-- :class="{ activeClass: timeDay == item }" -->
                <span v-if="type == 'Month'"> {{ item }} </span>
                <span
                  v-if="type == 'week'"
                  :class="{ activeBgClass: isSpecialDay(item) }"
                >
                  {{ item }}
                </span>
                <span
                  v-if="type == 'today'"
                  :class="{ activeClass: timeDay == item }"
                >
                  {{ item }}
                </span>
              </div>
              <!-- 下个月 -->
              <div
                v-for="item in 7 - nextDays"
                :key="item + 'next'"
                class="lastday"
              >
                {{ item }}
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="18" style="height: calc(100vh - 170px);">
        <div style="background-color: #fff;position: relative;top: -55px">
          <FullCalendar
            ref="fullCalendar"
            :timeNow="timeNow"
            @weekTime="weekTime"
            @endTime="endTime"
            @prevBtn="prevBtn"
            @nextBtn="nextBtn"
            @changeBtn="changeBtn"
          >
          </FullCalendar>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from "moment";
moment.suppressDeprecationWarnings = true;
import FullCalendar from "@/components/FullCalendar";

export default {
  components: {
    // 注册
    FullCalendar,
  },
  data() {
    return {
      activeIcon: "",
      activeIcon1: "",

      heightStyle: "",
      nowDay: moment(),
      currentMonday: moment().startOf("isoWeek"),
      startTime: "",
      endTime1: "",
      weekStart1: "",
      type: "week",
      timeNow: "",
      weekDays: [],
      weekDays1: [],
      timeDay: "",
      changeTime: "",
      preDays: 30,
      nextDays: 7,
      curYear: moment().year(), //当前年
      curMonth: moment().month() + 1, //当前月
      week: ["一", "二", "三", "四", "五", "六", "日"],
      firstDay: 1, //获取当月第一天是星期几;星期日为 0，星期六为 6
      curDays: moment().daysInMonth(), //获取当月一共有多少天
    };
  },

  mounted() {
    this.firstDay = moment(`${moment().year()}-${moment().month() + 1}`)
        .startOf("month")
        .day()
        if (this.firstDay === 0) {
          this.firstDay = 7
        }
    this.getPreMonthDays();
    this.getNextMonthDays();
    let now = new Date();
    this.timeDay = now.getDate();
    const weekStart = moment().startOf("isoWeek");
    for (let i = 0; i < 7; i++) {
      const day = moment(weekStart).add(i, "days");
      this.weekDays.push(day.format("YYYY-MM-DD"));
    }
    this.weekDays.map((item) => {
      this.weekDays1.push(moment(item).format("D"));
    });
    console.log(this.weekDays1, 87845656566);
    this.timeNow = moment().format("YYYY-MM-DD");
    console.log(this.curDays, 789456556);
    this.getHeight();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "classroomIndex",
      });
    },
    getHeight() {
      const element = this.$refs.fullCalendar;
      if (element) {
        const height = element.$el.clientHeight - 55;
        console.log(element, 87989859);
        console.log(height, 87989859);
        this.heightStyle = height + "px";
      }
    },
    //日
    preMonthtoday() {
      this.activeIcon = "1";
      this.activeIcon1 = "";

      let monthStr = "";
      const lastWeekMonday = this.nowDay.clone().subtract(1, "days");
      console.log(lastWeekMonday, 784546656);
      this.timeNow = lastWeekMonday.format("YYYY-MM-DD");
      this.nowDay = lastWeekMonday;
      monthStr = lastWeekMonday.format("M");
      this.timeDay = lastWeekMonday.format("D");
      console.log(lastWeekMonday.format("D"), 78656625323);
      if (this.curMonth != monthStr) {
        this.preMonth1();
        //this.timeDay = lastWeekMonday.format("D");
      }
    },
    nextMonthtoday() {
      this.activeIcon = "";
      this.activeIcon1 = "1";

      let monthStr = "";
      const lastWeekMonday = this.nowDay.clone().add(1, "days");
      console.log(lastWeekMonday, 784546656);
      this.timeNow = lastWeekMonday.format("YYYY-MM-DD");
      this.nowDay = lastWeekMonday;
      monthStr = lastWeekMonday.format("M");
      this.timeDay = lastWeekMonday.format("D");

      console.log(lastWeekMonday.format("D"), 78656625323);
      if (this.curMonth != monthStr) {
        this.nextMonth1();
        this.timeDay = lastWeekMonday.format("D");
      }
    },
    //周
    nextMonthweek() {
      console.log("下一周");

      this.activeIcon = "";
      this.activeIcon1 = "1";
      let monthStr = "";
      const lastWeekMonday = this.currentMonday.clone().add(7, "days");
      const lastWeekMondayend = this.currentMonday.clone().add(13, "days");
      this.timeNow = lastWeekMonday.format("YYYY-MM-DD");
      this.currentMonday = lastWeekMonday;
      this.startTime = lastWeekMonday.format("M");
      this.endTime1 = lastWeekMondayend.format("M");
      console.log(this.startTime, 78566661);
      console.log(this.endTime1, 78566661);
      monthStr = lastWeekMonday.format("M");
      console.log(monthStr, 7856666);

      this.weekDays = [];
      this.weekDays1 = [];

      for (let i = 0; i < 7; i++) {
        const day = moment(this.currentMonday).add(i, "days");
        this.weekDays.push(day.format("YYYY-MM-DD"));
      }
      this.weekDays.map((item) => {
        this.weekDays1.push(moment(item).format("D"));
      });
      console.log(this.weekDays1, 87845656566);
      if (this.curMonth != monthStr) {
        this.nextMonth1();
      }
    },
    preMonthweek() {
      console.log("上一周");

      this.activeIcon = "1";
      this.activeIcon1 = "";
      let monthStr = "";
      const lastWeekMonday = this.currentMonday.clone().subtract(7, "days");
      const lastWeekMondayend = this.currentMonday.clone().subtract(1, "days");
      this.timeNow = lastWeekMonday.format("YYYY-MM-DD");
      this.currentMonday = lastWeekMonday;
      this.startTime = lastWeekMonday.format("M");
      this.endTime1 = lastWeekMondayend.format("M");
      console.log(this.startTime, 7856666);
      console.log(this.endTime1, 7856666);

      monthStr = lastWeekMonday.format("M");
      this.weekDays = [];
      this.weekDays1 = [];

      for (let i = 0; i < 7; i++) {
        const day = moment(this.currentMonday).add(i, "days");
        this.weekDays.push(day.format("YYYY-MM-DD"));
      }
      this.weekDays.map((item) => {
        this.weekDays1.push(moment(item).format("D"));
      });
      console.log(this.weekDays1, 87845656566);
      if (this.curMonth != monthStr) {
        this.preMonth1();
      }
      // preMonth1
    },
    //
    generateDays(totalDays) {
      console.log(this.endTime1);
      console.log(this.startTime);

      if (this.endTime1 == this.startTime) {
        return Array.from({ length: totalDays }, (_, i) => (i + 1).toString());
      } else {
        return Array.from({ length: totalDays }, (_, i) =>
          (i + 1).toString().padStart(2, "0")
        );
      }
    },
    isSpecialDay(day) {
      console.log("点击了天");

      console.log(day);
      console.log(this.weekDays1);
      console.log(this.weekDays1.includes(day));

      return this.weekDays1.includes(day);
    },

    //日历
    changeBtn(val) {
      this.type = val;
      this.activeIcon1 = "";
      this.activeIcon = "";
    },
    preMonth1() {
      this.curMonth--;
      // 如果小于1表示上一年;重置日期
      if (this.curMonth < 1) {
        this.curYear--;
        this.curMonth = 12;
      }
      this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth();
      this.firstDay = moment(`${this.curYear}-${this.curMonth}`)
        .startOf("month")
        .day();
      if (this.firstDay == 0) {
        this.firstDay = 7;
      }
      if (this.curMonth == moment().month() + 1) {
        let now = new Date();
        this.timeDay = now.getDate();
      } else {
        this.timeDay = 0;
      }
      // 显示上个月日期
      this.getPreMonthDays();
      this.getNextMonthDays();
    },
    nextMonth1() {
      this.curMonth++;
      // 如果超过12表示下一年;重置日期
      if (this.curMonth > 12) {
        this.curYear++;
        this.curMonth = 1;
      }
      this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth();
      this.firstDay = moment(`${this.curYear}-${this.curMonth}`)
        .startOf("month")
        .day();
      if (this.firstDay == 0) {
        this.firstDay = 7;
      }
      if (this.curMonth == moment().month() + 1) {
        let now = new Date();
        this.timeDay = now.getDate();
      } else {
        this.timeDay = 0;
      }

      // 显示上个月日期
      this.getPreMonthDays();
      this.getNextMonthDays();
    },
    //
    endTime(val) {
      this.endTime1 = moment(val).format("M");
    },
    weekTime(val) {
      console.log(val, 789456465);
      if (this.type == "week") {
        this.startTime = moment(val).format("M");
        let timeStrYM = moment(val).format("YYYY-M");
        let timeStr1 = moment(val).format("YYYY-M");
        let timeStrMounth = moment(val).format("M");
        let timeStr = this.curYear + "-" + this.curMonth;
        this.weekStart1 = moment(val).format("YYYY-MM-DD");
        this.weekDays = [];
        this.weekDays1 = [];
        for (let i = 0; i < 7; i++) {
          const day = moment(this.weekStart1).add(i, "days");
          this.weekDays.push(day.format("YYYY-MM-DD"));
        }
        this.weekDays.map((item) => {
          this.weekDays1.push(moment(item).format("D"));
        });
        console.log(timeStr, 111);
        console.log(timeStr1, 111);
        console.log(timeStrMounth, 111);
        console.log(this.curMonth, 111);
        if (this.curYear == moment(val).format("YYYY")) {
          this.curMonth = moment(val).format("M");
          this.curDays = moment(timeStrYM).daysInMonth();
          this.firstDay = moment(timeStrYM)
            .startOf("month")
            .day();
          if (this.firstDay == 0) {
            this.firstDay = 7;
          }
          if (this.curMonth == moment().month() + 1) {
            let now = new Date();
            this.timeDay = now.getDate();
          } else {
            this.timeDay = 0;
          }
          // 显示上个月日期
          this.getPreMonthDays();
          this.getNextMonthDays();
        }
        if (this.curYear != moment(val).format("YYYY")) {
          this.curYear = moment(val).format("YYYY");
          this.curMonth = moment(val).format("M");
          this.curDays = moment(timeStrYM).daysInMonth();
          this.firstDay = moment(timeStrYM)
            .startOf("month")
            .day();
          if (this.firstDay == 0) {
            this.firstDay = 7;
          }
          if (this.curMonth == moment().month() + 1) {
            let now = new Date();
            this.timeDay = now.getDate();
          } else {
            this.timeDay = 0;
          }
          // 显示上个月日期
          this.getPreMonthDays();
          this.getNextMonthDays();
        }
      } else if (this.type == "today") {
        console.log(val, 124558787);
        this.timeDay = moment(val).format("D");
        let timeStrYM = moment(val).format("YYYY-MM");
        console.log(this.timeDay, 124558787);
        console.log(timeStrYM, 124558787);

        if (this.curYear == moment(val).format("YYYY")) {
          this.curMonth = moment(val).format("M");
          this.curDays = moment(timeStrYM).daysInMonth();
          this.firstDay = moment(timeStrYM)
            .startOf("month")
            .day();
          if (this.firstDay == 0) {
            this.firstDay = 7;
          }

          this.getPreMonthDays();
          this.getNextMonthDays();
        }
        if (this.curYear != moment(val).format("YYYY")) {
          this.curYear = moment(val).format("YYYY");
          this.curMonth = moment(val).format("M");
          this.curDays = moment(timeStrYM).daysInMonth();
          this.firstDay = moment(timeStrYM)
            .startOf("month")
            .day();
          if (this.firstDay == 0) {
            this.firstDay = 7;
          }

          this.getPreMonthDays();
          this.getNextMonthDays();
          // 显示上个月日期
          this.getPreMonthDays();
          this.getNextMonthDays();
        }
      } else if (this.type == "Month") {
        console.log(val, 124558787);
        this.timeDay = moment(val).format("D");
        let timeStrYM = moment(val).format("YYYY-MM");
        console.log(this.timeDay, 124558787);
        console.log(timeStrYM, 124558787);

        if (this.curYear == moment(val).format("YYYY")) {
          this.curMonth = moment(val).format("M");
          this.curDays = moment(timeStrYM).daysInMonth();
          this.firstDay = moment(timeStrYM)
            .startOf("month")
            .day();
          if (this.firstDay == 0) {
            this.firstDay = 7;
          }

          this.getPreMonthDays();
          this.getNextMonthDays();
        }
        if (this.curYear != moment(val).format("YYYY")) {
          this.curYear = moment(val).format("YYYY");
          this.curMonth = moment(val).format("M");
          this.curDays = moment(timeStrYM).daysInMonth();
          this.firstDay = moment(timeStrYM)
            .startOf("month")
            .day();
          if (this.firstDay == 0) {
            this.firstDay = 7;
          }

          this.getPreMonthDays();
          this.getNextMonthDays();
          // 显示上个月日期
          this.getPreMonthDays();
          this.getNextMonthDays();
        }
      }
    },
    nextBtn(val) {
      this.activeIcon = "";
      this.activeIcon1 = "";
      this.type = val;
      if (val == "Month") {
        this.nextMonth1();
      }
    },
    prevBtn(val) {
      this.type = val;
      this.activeIcon = "";
      this.activeIcon1 = "";
      if (val == "Month") {
        this.preMonth1();
      }
    },
    clickBtn(row) {
      console.log("点击日历某天");
      console.log(row);
      console.log(this.weekDays1);

      if (this.type == "week") {
        return;
      }

      let day = "";
      if (row < 10) {
        day = "0" + row;
      } else {
        day = row;
      }
      let Month = "";
      if (this.curMonth < 10) {
        Month = "0" + this.curMonth;
      } else {
        Month = this.curMonth;
      }

      this.timeDay = row;
      this.changeTime = this.curYear + "-" + Month + "-" + day;
      console.log(this.changeTime, 7894566);
      this.timeNow = this.changeTime;

      console.log("当前日期");
      console.log(this.timeNow);

      this.weekDays1 = this.getWeekList(this.timeNow);

      console.log("点击时候的周列表");
      console.log(this.weekDays1);
    },

    getWeekList(inputDate) {
      const inputMoment = moment(inputDate);
      const startOfWeek = inputMoment
        .clone()
        .startOf("isoWeek")
        .isoWeekday(1);
      const endOfWeek = inputMoment
        .clone()
        .endOf("isoWeek")
        .isoWeekday(7);
      const weekList = [];

      let currentDay = startOfWeek.clone();
      while (currentDay <= endOfWeek) {
        weekList.push(String(currentDay.date()));
        currentDay.add(1, "day");
      }

      return weekList;
    },

    preMonth() {
      this.activeIcon = "1";
      this.activeIcon1 = "";
      this.curMonth--;
      // 如果小于1表示上一年;重置日期
      if (this.curMonth < 1) {
        this.curYear--;
        this.curMonth = 12;
      }
      this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth();
      this.firstDay = moment(`${this.curYear}-${this.curMonth}`)
        .startOf("month")
        .day();
      if (this.firstDay == 0) {
        this.firstDay = 7;
      }
      if (this.curMonth == moment().month() + 1) {
        let now = new Date();
        this.timeDay = now.getDate();
      } else {
        this.timeDay = 0;
      }

      let changeTime1 = "";
      let Month = "";

      if (this.curMonth < 10) {
        Month = "0" + this.curMonth;
      } else {
        Month = this.curMonth;
      }
      console.log(Month, 7894565461111);
      changeTime1 = this.curYear + "-" + Month + "-" + "01";
      console.log(changeTime1, 7894565461111);
      this.timeNow = changeTime1;

      // 显示上个月日期
      this.getPreMonthDays();
      this.getNextMonthDays();
    },
    nextMonth() {
      this.activeIcon = "";
      this.activeIcon1 = "1";
      this.curMonth++;
      // 如果超过12表示下一年;重置日期
      if (this.curMonth > 12) {
        this.curYear++;
        this.curMonth = 1;
      }
      this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth();
      this.firstDay = moment(`${this.curYear}-${this.curMonth}`)
        .startOf("month")
        .day();
      if (this.firstDay == 0) {
        this.firstDay = 7;
      }
      if (this.curMonth == moment().month() + 1) {
        let now = new Date();
        this.timeDay = now.getDate();
      } else {
        this.timeDay = 0;
      }
      let changeTime1 = "";
      let Month = "";

      if (this.curMonth < 10) {
        Month = "0" + this.curMonth;
      } else {
        Month = this.curMonth;
      }
      console.log(Month, 7894565461111);
      changeTime1 = this.curYear + "-" + Month + "-" + "01";
      console.log(changeTime1, 7894565461111);
      this.timeNow = changeTime1;

      // 显示上个月日期
      this.getPreMonthDays();
      this.getNextMonthDays();
    },
    // 获取上个月剩余天数
    getPreMonthDays() {
      if (this.firstDay == 1) return; //表示上个月无剩余天数
      let month = this.curMonth;
      let year = this.curYear;
      month--;
      if (month == 0) {
        year--;
        month = 12;
      }
      // 获取上个月的天数
      const days = moment(`${year}-${month}`).daysInMonth();
      this.preDays = days;
    },
    // 获取下个月要显示的天数
    getNextMonthDays() {
      let month = this.curMonth;
      let year = this.curYear;
      // 获取当月最后一天是星期几
      const lastDay = moment(`${year}-${month}`)
        .endOf("month")
        .day();
      this.nextDays = lastDay == 0 ? 7 : lastDay;
    },
  },
};
</script>

<style lang="scss">
.activeBgClass {
  background-color: #e8edfb;
  padding: 3px;
  border-radius: 2px;
}

.activeClass {
  // background-color: #224CDA;
  background: #e8edfb;

  padding: 3px;
  border-radius: 2px;
  // color: #fff;
}

.classroomDetailsTop {
  width: 100%;
  padding: 32px 30px 32px 30px;
  background-color: #fff;
  box-sizing: border-box;
}

.classroomDetails {
  height: calc(100vh - 80px);
  background: #f1f7fe;
  margin: 10px;
  // overflow-y: auto;
  overflow: hidden;
}

.wrap {
  width: 100%;
  height: 100%;

  .weeks {
    padding: 0 15px;
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    display: flex;

    .week {
      // width: 100px;
      width: calc(100% / 7);
      line-height: 50px;
      text-align: center;
      // background: gainsboro;
    }
  }

  .days {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
    box-sizing: border-box;

    .lastday,
    .curday {
      width: calc(100% / 7);
      // line-height: 50px;
      text-align: center;
      cursor: pointer;
      margin-bottom: 10px;
      color: #323233;
    }

    .lastday {
      color: #c8c9cc;
    }
  }
}
</style>
